/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/lenta/r/'>.
 * /r/-пагинация (§3.2), сплат матчит и голый /lenta/r
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import Articles from '@routes/Articles';
import { getQueryClient } from '../../../providers/query';
import {
  articlesInfiniteQueryOptions,
  buildArticlesListParams
} from '@queries/index';
import { getURLProps } from '@utils/setPagesUrl';
import { isContentNotFoundError } from '../../../api/contentNotFound';
import { assertValidListUrl } from '../../../ssrListParams';

export const Route = createFileRoute('/lenta/r/$')({
  /**
   * ЭТАП 2 — честный 404 несуществующей страницы списка статей
   * (/lenta/r/page/99999): бэк (getArticles) кидает CONTENT_NOT_FOUND через
   * checkPageExists (и checkPageNumber для page < 1) -> notFound() ->
   * HTTP 404 + контент /404 без редиректа. ensureInfiniteQueryData
   * дедуплицируется с root-префетчем (общий buildArticlesListParams).
   * page 1 не проверяем; клиентскую навигацию не блокируем.
   */
  loader: async ({ location }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    // Хвост /r/ обязан быть каноническим: чужие ключи, битые значения
    // и /r/page/1 — честный 404, см. src/ssrListParams.ts
    assertValidListUrl('lenta', location.pathname);
    const urlProps = getURLProps({ pathname: location.pathname });
    const page = parseInt(`${urlProps.page}`, 10);
    if (Number.isNaN(page) || page === 1) {
      return;
    }
    const queryClient = getQueryClient();
    const options = articlesInfiniteQueryOptions(
      buildArticlesListParams(urlProps.search || undefined),
      page
    );
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureInfiniteQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={Articles} path='/lenta/r/' />
});
